import React from 'react';

const Loader = () => {
    return (
        <div className='border-slate-600 border-8 border-b-amber-400 w-28
        h-28 rounded-full mx-auto my-20 animate-spin'>

        </div>
    );
};

export default Loader;